import { render } from "./ProfileTelegram.vue?vue&type=template&id=64379ef4&lang=pug"
import script from "./ProfileTelegram.vue?vue&type=script&lang=js"
export * from "./ProfileTelegram.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__